import Data from '@/data'
import { Button, Checkbox, Dialog, ScrollBox } from '@maxroll-media-group/common-libs'
import { useState } from 'react'

import EditingContext from '@/store/editingContext'
import { PlannerDialog } from '../../utils/dialog'
import { characterImage, ClassBackground } from '../../utils/images'
import { useLoadCharacter, useLoadCharacters } from './api'
import styles from './character-loader.module.scss'

export function CharacterLoaderDialog({
  type = 'planner',
  onClose
}: {
  type?: 'planner' | 'passives' | 'atlas'
  onClose: () => void
}) {
  const characters = EditingContext.useStateView('apiCharacters')
  const loadCharacter = useLoadCharacter(type)

  const [addToExistingProfile, setAddToExistingProfile] = useState(true)

  return (
    <PlannerDialog className={styles.ImportCharacter} modal title="Select Character" onClose={onClose}>
      <Dialog.Content>
        {type === 'planner' && (
          <div className={styles.ImportCharacter__checkbox}>
            <Checkbox
              label="Overwrite current planner"
              value={!addToExistingProfile}
              onChange={setAddToExistingProfile}
            />
          </div>
        )}

        <ScrollBox
          type="vertical"
          className={styles.ImportCharacter__buildsWrapper}
          innerClassName={styles.ImportCharacter__buildsList}>
          {characters.map((character, index) => {
            const ascendancyId = character.class in Data.ascendancyClass ? character.class : undefined
            const classId = ascendancyId
              ? Data.ascendancyClass[ascendancyId]!
              : Object.entries(Data.characters).find(([, val]) => val.name === character.class)?.[0]

            const charClass = classId ? Data.characters[classId] : undefined
            const charAscendancy = ascendancyId ? charClass?.ascendancies[ascendancyId] : undefined

            const ascOrClassName = charAscendancy?.name ?? charClass?.name ?? ''

            return (
              <div
                key={index}
                className={styles.PlannerBuild}
                onClick={() => {
                  onClose()
                  loadCharacter(character, addToExistingProfile)
                }}>
                <ClassBackground name={ascOrClassName} />

                <div className={styles.PlannerBuild__charWrapper}>
                  <div
                    className={styles.PlannerBuild__class}
                    style={{
                      backgroundImage: `url(${characterImage(ascOrClassName)})`
                    }}
                  />
                  <div className={styles.PlannerBuild__data}>
                    <div className={styles.PlannerBuild__name}>{character.name}</div>
                    <div className={styles.PlannerBuild__info}>
                      <span>
                        Level <b>{character.level}</b>
                      </span>
                      {ascOrClassName ? (
                        <span>
                          <b>{ascOrClassName}</b>
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </ScrollBox>
      </Dialog.Content>
      <Dialog.Footer>
        <button onClick={onClose}>Close</button>
      </Dialog.Footer>
    </PlannerDialog>
  )
}

export function CharacterLoader() {
  const { showCharImportModal, setShowCharImportModal, loadCharacters } = useLoadCharacters()

  return (
    <div>
      <Button buttonStyle="primary" onClick={loadCharacters}>
        Import from your PoE Account!
      </Button>

      {showCharImportModal && <CharacterLoaderDialog type="planner" onClose={() => setShowCharImportModal(false)} />}
    </div>
  )
}
